 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		382: 0,
 		279: 0,
 		280: 0,
 		284: 0,
 		286: 0,
 		288: 0,
 		289: 0,
 		290: 0,
 		338: 0,
 		339: 0,
 		347: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","216":"AddClosedAlertIDUseCase","217":"CreateDeviceUseCase","218":"CreateDomestikaFollowUseCase","219":"CreateJWTUserUseCase","220":"CreateUserLiveSessionUseCase","221":"CurrentUserUseCase","222":"CurrentWithoutRelationshipsUserUseCase","223":"DeleteDeviceUseCase","224":"DeleteFollowUseCase","225":"ENV_CONFIG1","226":"ENV_CONFIG4","227":"ENV_CONFIG5","228":"ENV_CONFIG6","229":"ENV_CONFIG7","230":"FinishUserLiveSessionUseCase","231":"GetAccessTokenUserUseCase","232":"GetAdvanceGDPRStatusUserUseCase","233":"GetAllBlogUseCase","234":"GetAreasCourseUseCase","235":"GetCartCourseUseCase","236":"GetCategoriesCourseUseCase","237":"GetCourseUseCase","238":"GetFinalProjectVideoByCourseIDCourseUseCase","239":"GetGDPRStatusUserUseCase","240":"GetListLiveFeedbackQuestionUseCase","241":"GetListLiveSessionUseCase","242":"GetListLiveStreamUseCase","243":"GetLiveChannelUseCase","244":"GetLiveSessionUseCase","245":"GetOrganizationUseCase","246":"GetPlusPromotionUseCase","247":"GetPostContentBlogUseCase","248":"GetPromotionCodeAlertUseCase","249":"GetPromotionUseCase","250":"GetPubnubCredentialsUseCase","251":"GetSessionDataUserUseCase","252":"GetSimpleUserUseCase","253":"GetSoftwaresCourseUseCase","254":"GetUserAlertUseCase","255":"GetVideoProgressListCourseUseCase","256":"GetVideoSpeedUserUseCase","257":"GetVideoVolumeUserUseCase","258":"LogoutUserUseCase","259":"PathToRegexp","260":"RefreshAccessTokenUserUseCase","261":"RemoveAccessTokenUserUseCase","262":"SearchCourseUseCase","263":"SendHeaderTrackingUseCase","264":"SendLiveFeedbackAnswersUseCase","265":"SendPlayerTrackingUseCase","266":"SendTrackingUseCase","267":"SendVideoProgressCourseUseCase","268":"SetAdvanceGDPRStatusUserUseCase","269":"SetGDPRStatusUserUseCase","270":"SetVideoSpeedUserUseCase","271":"SetVideoVolumeUserUseCase","272":"UpdateLanguageUserUseCase","273":"UpdateLiveSessionUseCase","274":"UpdateVideoAudioAndSubtitlesCourseUseCase","275":"UpdateVideoProgressCourseUseCase","276":"ViewPageTrackingUseCase","346":"vendors~AddClosedAlertIDUseCase","347":"vendors~AmplitudeJS","348":"vendors~SearchCourseUseCase","349":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"99a7fa9d1a49f299b3aa","1":"3c12ce3c3b589f98ade0","2":"4257e7d178794935639f","3":"bb966182ca410891d498","4":"d0dced47746bf5ac4aa5","5":"178f3a542eb91b3ad347","215":"53a8e75e495815489a16","216":"02d824689f7e4c798f5f","217":"eb8ed83485b7ec4482d8","218":"b3d14312bbac6c699cda","219":"bd234d5ae2035882fa39","220":"fa10719fb9faec74bc70","221":"284fe8ba9c81598988c2","222":"7cb350873829a5e992ff","223":"a649f0f318038ad0e584","224":"a825ec59ab516c6ce087","225":"7a2133d4855264afac5a","226":"26477502bd9dc0a4e0f4","227":"b9d27ffc74058fa29b41","228":"a9889c9a17beccc1b5f1","229":"41e1724ca21cfdff5493","230":"ac8701bddc5fb3390b0c","231":"f0b502129954fb68860e","232":"283e41e3db43c3ed073b","233":"55963cc11ec60dd69f3e","234":"385ccd86e6a9e9d71e9c","235":"60034250c5fbd7c2d778","236":"2b87b560825d6c3b9dd9","237":"2236fecd128634098735","238":"dd1560c523b6e8577704","239":"c52e324cbe9c160883a3","240":"16a9c6cfa7d52f01adc1","241":"ac5330df7c9efb9a4b9a","242":"996801cbb84971bb2799","243":"052a769e78228f15a2af","244":"4f9c765177a9aad4bf7c","245":"0fc6cea9de2531c30fe9","246":"eaad61e3bf12b6c1f8e9","247":"30f4d5867fa65471bb04","248":"5201329daddb70783540","249":"b03baf4603ddc880e017","250":"e4efe930cfe0ec8203c5","251":"64379519feec99e064b8","252":"09c20a9d2e8982501fcb","253":"f506aa4e66c90f29769f","254":"73228063e49533c3448b","255":"38bb627f932bf2e37822","256":"0e87fdf55ee8d0715c77","257":"e0aedb25d8640d033dbd","258":"5907952556a943cf03c6","259":"ba8ff2a888686897be35","260":"f1bae1a2fea0115cc822","261":"a202116f4d93e3c2c765","262":"0d97c6208d47dd53f6bc","263":"9c6306dcb14098909161","264":"34ea614a7381bc3cf14d","265":"166b52f1bfe1dd1666c3","266":"859e0eef0f792e6016da","267":"30f470af6acb71f21c94","268":"56742d517f9b11f90656","269":"773e4e184b4df66a5d84","270":"5ad73c4fb95c6de237ae","271":"f1b2b6171e0227200b69","272":"6b24a03ce4b00622c665","273":"ffa818bd865f5486fb6d","274":"70248f394423549de628","275":"e93146f217617367f0dd","276":"a5ae457473f3297f1820","346":"bb0bda2e81b9281de699","347":"035adb636d9c0021cd51","348":"a6b549a52ced7701e979","349":"418dfd06724226c79080","416":"a61df7707921c1d86ed7","418":"d3425026a930b360b494","419":"d43ad12d926a8d02a144","637":"d688508452a8228b2fee","638":"c8d1af7a702eeea52a10","639":"512110ba1d9f3489f589"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2169);
